import {
	connect
} from 'react-redux'
import PackingBoxNumberEditComponent from '../components/PackingBoxNumberEditComponent.jsx';
import {
	changePackingItemValue,
	editPackingBoxNumber
} from '../actions';

const mapStateToProps = (state) => ({
	packingItem: state.getIn(['packingReducer', 'packingItem']),
	packingItemValidation: state.getIn(['packingReducer', 'packingItemValidation']),
	alertStyle: state.getIn(['packingReducer', 'alertStyle']),
	alertMessage: state.getIn(['packingReducer', 'alertMessage']),

	activePage: state.getIn(['packingItemListReducer', 'activePage']),
	itemPerPage: state.getIn(['packingItemListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	editBoxNumber: (packingItem, pagingData) => {
		dispatch(editPackingBoxNumber(packingItem, pagingData));
	},
	setValue: (id, value) => {
		dispatch(changePackingItemValue({
			id: id,
			value: value
		}))
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	packingItem: stateProps.packingItem,
	packingItemValidation: stateProps.packingItemValidation,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	editBoxNumber: () => dispatchProps.editBoxNumber(stateProps.packingItem, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}),
	setValue: dispatchProps.setValue
})

const PackingBoxNumberEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(PackingBoxNumberEditComponent)

export default PackingBoxNumberEditContainer;


// WEBPACK FOOTER //
// ./src/containers/PackingBoxNumberEditContainer.jsx